import React from 'react'
import { Spinner } from 'reactstrap'

const LoadingWidget = ({ size }) => (
  <div className='text-center'>
    <Spinner color='primary' type='grow' size={size} />
  </div>
)

export default LoadingWidget
